import React, { useEffect, useState } from 'react';
import { Table, Button } from '@mantine/core';
import { format } from 'date-fns';
import {ReactComponent as Icon } from '../../assets/icons/Edit.svg'
import SorterPopUp from './SorterPopUp';
import { useDisclosure } from '@mantine/hooks';
import TableMedusa from '../../components/Table';
import {SorterListProps, Options} from '../../types/sorter';
import { useSorterOptions } from '../../context/SorterOptionsContext';
import { updateSorterOptions } from './SorterUtils';

const SorterList = ({aggrSorters, sorters, onSave, onDelete}: SorterListProps)=>{
    const [editingSorter, setEditingSorter] = useState<number>(0); //id
    const [opened, { open, close }] = useDisclosure(false);
    const icon = <Icon width={19} height={19}></Icon>;

     const {
        setCenterOptions,
        setFirmwareOptions,
        setColorModelOptions,
        setReuseModelOptions,
        setRecyclingModelOptions,
      } = useSorterOptions();

    useEffect(()=>updateSorterOptions(setCenterOptions, setFirmwareOptions, setColorModelOptions, setReuseModelOptions, setRecyclingModelOptions),[opened])

    const onClickEdit = (id:number) =>{
      setEditingSorter(id);
      open();
    }


    const rows = aggrSorters?.map(({sorterID, sorterName, countOfBelts, sumHoppers}) => (
             <Table.Tr key={sorterID}>
                  <Table.Td>{sorterID}</Table.Td>
                  <Table.Td>{sorterName}</Table.Td>
                  <Table.Td>{countOfBelts}</Table.Td>
                  <Table.Td>{sumHoppers}</Table.Td>
                  <Table.Td>
                      <Button variant="transparent" onClick={()=>onClickEdit(sorterID)}>{icon}</Button>
                  </Table.Td>
            
                </Table.Tr>

    ));



    return(
        <div>
           <SorterPopUp opened={opened} close={close} title="Edit" edit={true} onSave={onSave} onDelete={onDelete} sorter={sorters.filter((sorter)=> sorter.id === editingSorter)}></SorterPopUp>
           <TableMedusa headers={["ID", "Name", "Belts", "Hoppers"]} rows={rows}></TableMedusa>
        </div>
    );
}


export default SorterList